import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#002B48',
                gray: '#D9D9D9',
                dark: '#002B48',
            }
        }
    }
});
